import axios from 'axios'
import moment from 'moment'
import Utils from '../../utils/utils'
import vue from 'vue'

export async function getViolationData(condition = {}) {
  if (Utils.isEmptyObject(condition.startTime) || Utils.isEmptyObject(condition.endTime)) {
    console.error('iisi getViolationData: time is null')
    return
  }
  // Violation?sttime=2022/07/27%2012:00&endtime=2022/07/29%2012:00&&area=1&&type=(2是違規闖入4是封閉預警)

  let response = {}
  let startTime = encodeURIComponent(moment(condition.startTime).format())
  let startTimeQuery = startTime ? `?sttime=${startTime}` : ''
  let endTime = encodeURIComponent(moment(condition.endTime).format())
  let endTimeQuery = endTime ? `&endtime=${endTime}` : ''
  let scenicAreaIdQuery = Utils.isEmptyObject(condition.scenicAreaId) ? '' : `&areas=${condition.scenicAreaId}`
  let typeQuery= '';
  if((condition.type).length > 1) {
    //判斷查詢多個違規類型，則使用迴圈串接查詢條件
    for(let i = 0; i < (condition.type).length; i++) {
    typeQuery = typeQuery+`&type=${condition.type[i]}`;
  }}
  else{
    typeQuery = Utils.isEmptyObject(condition.type) ? '' : `&type=${condition.type}`
  }

  try {
      response = await vue.http.get(`/api/Violation${startTimeQuery}${endTimeQuery}${scenicAreaIdQuery}${typeQuery}`)

  } catch (err) {
      console.error('iisi getViolationData: ', err)
      return null
  }

  Utils.setApiResponsSuccess(response)
  return response
}

export async function stpDashboardViolationCount(condition = {}) {
  let response = await getViolationData(condition)
  const count = Utils.isEmptyObject(response) ? 0 : response.body.length

  if(Utils.isEmptyObject(response) || !response.success || count === 0) {
    return {count: 0}
  }

  const sortViolation = response.body.sort((a,b) => moment(a.time) - moment(b.time))

  const data = sortViolation[0]
  data.count = count
  return data
}